import { createSelector, createFeatureSelector, ActionReducerMap } from '@ngrx/store';
import * as fromWorkflow from './workflow.reducer';
import { ManagementModuleState } from '../';

const selectManagementModuleState = createFeatureSelector<ManagementModuleState>('management');

const selectWorkflowState = createSelector(selectManagementModuleState, (state: ManagementModuleState) => state?.workflow);

export const selectSelectedWorkflow = createSelector(selectWorkflowState, fromWorkflow.getSelectedWorkflow);

export const selectSelectedWorkflowStep = createSelector(selectWorkflowState, fromWorkflow.getSelectedWorkflowStep);

export const selectSelectedWorkflowAction = createSelector(selectWorkflowState, fromWorkflow.getSelectedWorkflowAction);

export const selectSelectedView = createSelector(selectWorkflowState, fromWorkflow.getSelectedView);

export const selectWorkflowStepForDelete = createSelector(selectWorkflowState, fromWorkflow.getWorkflowStepForDelete);

export const selectWorkflowStepActionForDelete = createSelector(selectWorkflowState, fromWorkflow.getWorkflowStepActionForDelete);

export const selectSelectedViewForDelete = createSelector(selectWorkflowState, fromWorkflow.getSelectedViewForDelete);

export const selectIsWorking = createSelector(selectWorkflowState, fromWorkflow.getIsWorking);

export const selectIsDirty = createSelector(selectWorkflowState, fromWorkflow.getIsDirty);

export const selectShowFormBuilder = createSelector(selectWorkflowState, fromWorkflow.getShowFormBuilder);

export const selectDetailView = createSelector(selectWorkflowState, fromWorkflow.getDetailView);

export const selectTableView = createSelector(selectWorkflowState, fromWorkflow.getTableView);

export const selectCardView = createSelector(selectWorkflowState, fromWorkflow.getCardView);

export const selectPopupView = createSelector(selectWorkflowState, fromWorkflow.getPopupView);

export const selectFilterView = createSelector(selectWorkflowState, fromWorkflow.getFilterView);

export const selectPrefsView = createSelector(selectWorkflowState, fromWorkflow.getPrefsView);

export const selectDeleteSteps = createSelector(selectWorkflowState, fromWorkflow.getDeleteSteps);

export const selectIsStepMigration = createSelector(selectWorkflowState, fromWorkflow.getIsStepMigration);

export const selectStepMigrationUId = createSelector(selectWorkflowState, fromWorkflow.getStepMigrationUId);

export const selectOldStepMigrationUId = createSelector(selectWorkflowState, fromWorkflow.getOldStepMigrationUId);

export const selectSelectedWorkflowStepRule = createSelector(selectWorkflowState, fromWorkflow.getSelectedWorkflowStepRule);
export const selectWorkflowStepRuleForDelete = createSelector(selectWorkflowState, fromWorkflow.getWorkflowStepRuleForDelete);
export const selectRuleImplementations = createSelector(selectWorkflowState, fromWorkflow.getRuleImplementations);

export const selectWizardViews = createSelector(selectWorkflowState, fromWorkflow.getWizardViews);
export const selectSelectedViewName = createSelector(selectWorkflowState, fromWorkflow.getViewName);
